/* eslint-disable no-unused-vars */
import { $http } from '@/utils/http'
import queryString from 'query-string'
import host from '@/utils/host'

export default {
  namespaced: true,
  state: {
    loading: false,
    showReportData: false,
    homepageUv: { // 此处uv就当访问账号数理解，方便命名。此需求访问账号数和uv实际含义略有不同，忽略。
      yesterday: 0, // 昨日
      sevenDays: 0, // 近7天
      thirtyDays: 0 // 近30天
    },
    clickNum: {}, // 点击数, 点击账号数 或 点击数
    topUser: [], // top商家账号
    period: 30, // 30: 近30天， 7: 近7天， 1: 昨日
    logType: 'uv', // 数据维度 uv: 点击账号数， pv: 点击次数
    pageID: 0,
    openedMenuKey: '',
    topUserVisible: false,
    jumpToken: '' //跳转token
  },
  mutations: {
    setLoading(state, data) {
      state.loading = data
    },
    setHomepageUv(state, data) {
      state.homepageUv = data
    },
    setClickNum(state, data) {
      state.clickNum = data
    },
    setTopUser(state, data) {
      state.topUser = data
    },
    setToken(state, data) {
      state.jumpToken = data
    },
    setPeriod(state, data) {
      state.period = data
    },
    setLogType(state, data) {
      state.logType = data
    },
    setShowReportData(state, data) {
      state.showReportData = data
    },
    setPageID(state, data) {
      state.pageID = data
    },
    setOpenedMenuKey(state, data) {
      state.openedMenuKey = data
    },
    setTopUserVisible(state, data) {
      state.topUserVisible = data
    }
  },
  actions: {
    // 查询首页访问账号数
    async getHomepageUv({ commit, state }) {
      const url = `${host.mapi}/admin-b/heatmap/page-uv?pageID=${state.pageID}`
      commit('setLoading', true)
      try {
        const res = await $http.get(url)
        commit('setHomepageUv', res)
      } catch(e) {
        console.log(e)
      } finally {
        commit('setLoading', false)
      }
    },
    // 查询菜单点击数据
    async getPositionCount({ state, commit }, queryAllLevel=false) {
      commit('setLoading', true)
      const { pageID, period, logType, openedMenuKey } = state
      const params = {pageID, period, logType}
      if (queryAllLevel && openedMenuKey) {
        const menuKeys = openedMenuKey.split('/')
        const url1 = `${host.mapi}/admin-b/heatmap/position-count?${queryString.stringify(params)}`
        let remoteFetchs = [$http.get(url1)]
        // 因为最多三级菜单，所以openedMenuKey最多到二级菜单的key
        if (menuKeys.length === 1) {
          let url2 = `${host.mapi}/admin-b/heatmap/position-count?${queryString.stringify({...params, openedMenuKey})}`
          remoteFetchs.push($http.get(url2))
        } else if (menuKeys.length === 2) {
          let url2 = `${host.mapi}/admin-b/heatmap/position-count?${queryString.stringify({...params, openedMenuKey: menuKeys[0]})}`
          let url3 = `${host.mapi}/admin-b/heatmap/position-count?${queryString.stringify({...params, openedMenuKey})}`
          remoteFetchs.push($http.get(url2))
          remoteFetchs.push($http.get(url3))
        }
        try {
          const resArr = await Promise.all(remoteFetchs)
          let res = {}
          resArr.forEach(item => {
            res = {...res, ...item}
          })
          commit('setClickNum', {...state.clickNum, ...res})
        } catch (e) {
          console.log(e)
        } finally {
          commit('setLoading', false)
        }
      } else {
        params.openedMenuKey = openedMenuKey
        const url = `${host.mapi}/admin-b/heatmap/position-count?${queryString.stringify(params)}`
        try {
          const res = await $http.get(url)
          commit('setClickNum', {...state.clickNum, ...res})
        } catch(e) {
          console.log(e)
        } finally {
          commit('setLoading', false)
        }
      }
    },
    // 查询top商家数
    async getTopUser({ commit, state }, payload={}) {
      commit('setTopUser', [])
      commit('setTopUserVisible', true)
      const { pageID, period } = state
      const params = {pageID, period, ...payload}
      const url = `${host.mapi}/admin-b/heatmap/top-user?${queryString.stringify(params)}`
      commit('setLoading', true)
      try {
        const res = await $http.get(url)
        commit('setTopUser', res)
      } catch(e) {
        console.log(e)
      } finally {
        commit('setLoading', false)
      }
    }, 
    // 获取小程序孩子王商家登陆身份token
    async getJumpToken({ commit, state }, payload={}) {
      commit('setToken', '') 
      const url = `${host.hbpsproxyapi}/hbp-sproxy-api/kwbsapi/h/unifyLogin/queryHzwOpenUserToken.do`
      commit('setLoading', true)
      try {
        const res = await $http.get(url)
        console.log(res.data)
        commit('setToken', res.data)
      } catch(e) {
        console.log(e)
      } finally {
        commit('setLoading', false)
      }
    }, 
    // 统计时间变化
    handlePeriodChange({ commit }, val) {
      commit('setPeriod', val)
    },
    // 数据维度变化
    handleLogTypeChange({ commit }, val) {
      commit('setLogType', val)
    },
    // 是否打开展示热力图数据开关
    isShowReportData({ commit }, val) {
      commit('setShowReportData', val)
    },
    // 初始化pageid
    initPageID({ commit }, val) {
      commit('setPageID', val)
    },
    resetPositionCount({ commit }) {
      commit('setClickNum', {})
    },
    // 菜单打开事件
    handleMenuOpenChange({ commit }, val) {
      commit('setOpenedMenuKey', val)
    },
    handleTopUserModalVisible({ commit }, val) {
      commit('setTopUserVisible', val)
    },
    // 初始化
    reset( {commit} ) {
      commit('setPeriod', 30)
      commit('setLogType', 'uv')
      commit('setTopUser', [])
      commit('setClickNum', {})
      commit('setShowReportData', false)
      commit('setTopUserVisible', false)
    }
  }
}